'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _createReducer2 = require('./utils/createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducer = void 0; // eslint-disable-line import/no-mutable-exports

try {
  (function () {
    var _createReducer;

    var fromJS = require('immutable').fromJS; // eslint-disable-line global-require

    var initialState = fromJS({
      show: false,
      title: ''
    });

    reducer = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.SHOW, function (state, _ref) {
      var payload = _ref.payload;
      return fromJS(_extends({
        show: true
      }, payload));
    }), _defineProperty(_createReducer, _actions.CLOSE, function () {
      return initialState;
    }), _createReducer));
  })();
} catch (error) {
  reducer = function reducer() {
    (0, _warning2.default)(false, 'You must install immutable-js for the immutable reducer to work!');
  };
}

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/lib/reducer-immutable.js
// module id = ./node_modules/react-redux-sweetalert/lib/reducer-immutable.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons